<template>
  <div
    :class="[
      { '--comments': isCommentThread, '--feeds': isFeed },
      'chat-block p-relative '
    ]"
    :style="{ padding: blockPadding }"
  >
    <template v-if="isBuilderContext()">
      <block-placeholder :icon="blockIcon" :text="blockText" />
    </template>
    <template v-else-if="messageThreadId">
      <message-thread
        :message-thread-id="messageThreadId"
        :is-comment-thread="isCommentThread"
        :is-feed="isFeed"
        :page-id="pageId"
        :placeholder="
          isCommentThread
            ? $t('components.blocks.chatBlock.addComment')
            : $t('components.blocks.chatBlock.writeSomething')
        "
      />
    </template>
  </div>
</template>

<script>
import { isBuilderContext } from "@/lib/utils"
import { withRatio, toPadding, BLOCK_BASE_HEIGHT } from "@shared/block-ratio"

import MessageThread from "@/components/message-thread/Thread"

export default {
  components: {
    MessageThread,
    BlockPlaceholder: () => import("@/components/stream/BlockPlaceholder")
  },

  props: {
    isCommentThread: { type: Boolean, default: false },
    isFeed: { type: Boolean, default: false },
    messageThreadId: { type: [Number, String], default: null },
    pageId: { type: [Number, String], default: null },
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 }
  },

  data() {
    return {
      BLOCK_BASE_HEIGHT
    }
  },

  computed: {
    height() {
      return withRatio(BLOCK_BASE_HEIGHT, this.heightRatio)
    },

    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    },

    blockIcon() {
      if (this.isCommentThread) {
        return "forum"
      } else if (this.isFeed) {
        return "calendar_view_day"
      } else {
        return "chat"
      }
    },

    blockText() {
      if (this.isCommentThread) {
        return this.$t('components.blocks.chatBlock.comments')
      } else if (this.isFeed) {
        return this.$t('components.blocks.chatBlock.feed')
      } else {
        return this.$t('components.blocks.chatBlock.groupChat')
      }
    }
  },

  methods: {
    withRatio,
    isBuilderContext
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.chat-block {
  user-select: none;
  min-height: 200px;
  height: 70vh;

  &.--comments,
  &.--feeds {
    height: auto;

    .block-placeholder {
      height: 70vh;
    }
  }

  &.--feeds {
    .message-thread {
      padding-bottom: $size--11;
    }
  }
}
</style>
